var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowHeadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#0F6CBD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98108 13.2187C7.53996 13.2193 7.11998 13.022 6.82846 12.6771L0.288088 4.93301C-0.141846 4.39929 -0.084115 3.60565 0.418115 3.14551C0.920345 2.68537 1.68337 2.72702 2.13667 3.23933L7.85575 10.0113C7.8874 10.0489 7.93307 10.0704 7.98108 10.0704C8.02909 10.0704 8.07476 10.0489 8.10641 10.0113L13.8255 3.23933C14.1126 2.88286 14.5626 2.71637 15.0013 2.80427C15.44 2.89218 15.7985 3.22069 15.9382 3.66269C16.0779 4.1047 15.9768 4.59084 15.6741 4.93301L9.13569 12.6743C8.84368 13.02 8.42313 13.2183 7.98108 13.2187Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHeadIcon);
export default __webpack_public_path__ + "static/media/arrow-head-icon.899eeae668c73b820992e7a701f9db48.svg";
export { ForwardRef as ReactComponent };